import React, { ButtonHTMLAttributes, ClassAttributes, LegacyRef } from 'react';
import styles from './category-second.module.scss';
import Skeleton from 'react-loading-skeleton';
import MiniProductCard from '@/components/ui/mini-product-card';
import { Button, Dropdown } from 'rsuite';
import { TabsData2, TabsData3 } from './data';
import IconType1 from '@/assets/icons/category-second-level/icon-view-cards-1.svg';
import IconType2 from '@/assets/icons/category-second-level/icon-view-cards-2.svg';
import { SortOrder } from './secondContent.types';
import { useLocale, useTranslations } from 'next-intl';
import { ProductVariantSortingInput } from '@/graphql';

const SecondContentTabs = ({
  productsLoading,
  productsData,
  handleMiniCardClick,
  isProductSelected,
  handleSortBy,
  productsSortBy,
  renderButton,
  cardsView,
  handleChange,
  openMobileMenu,
}: {
  productsLoading: boolean;
  productsData: any;
  handleMiniCardClick: (productId: string) => void;
  isProductSelected: (productId: string) => boolean;
  handleSortBy: (
    sortByCategory: SortOrder,
    sortByVariants: ProductVariantSortingInput
  ) => void;
  productsSortBy: SortOrder | null;
  handleChange: (view: string) => void;
  openMobileMenu: () => void;
  renderButton: (
    props: JSX.IntrinsicAttributes &
      ClassAttributes<HTMLButtonElement> &
      ButtonHTMLAttributes<HTMLButtonElement>,
    ref: LegacyRef<HTMLButtonElement> | undefined
  ) => void;
  cardsView: string;
}) => {
  const t = useTranslations('Components.category-second-content');
  const locale = useLocale();
  return (
    <div className={styles.classname}>
      <div className={styles.carousel}>
        {productsLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <div
                key={index}
                className={`${styles.skeletonForMiniProductCard}`}
              >
                <Skeleton />
              </div>
            ))
          : productsData?.products?.edges.map((miniCard: any) => {
              const productId = miniCard?.node.id;
              const isTrasnlationAvailable =
                miniCard?.node?.variants[0]?.trasnlation !== null &&
                miniCard?.node?.variants[0]?.translation?.name !== null;
              return (
                <MiniProductCard
                  key={miniCard?.node.id}
                  title={
                    locale === 'uz' && isTrasnlationAvailable
                      ? miniCard?.node?.variants[0]?.translation?.name
                      : miniCard?.node.name
                  }
                  image={miniCard?.node.thumbnail?.url}
                  onClick={() => handleMiniCardClick(productId)}
                  isSelected={isProductSelected(productId)}
                />
              );
            })}
      </div>

      <div className={styles.tabs}>
        <div className={styles.left}>
          <div className={styles.title}>{t('show')}:</div>
          {TabsData2().map((item, index) => (
            <Button
              key={item.title}
              type="button"
              className={`${styles.tab} ${
                productsSortBy?.field === item.click.field &&
                productsSortBy?.direction === item.click.direction
                  ? styles.activeTab
                  : ''
              }`}
              onClick={() => handleSortBy(item.click, TabsData3()[index].click)}
            >
              {item.title}
            </Button>
          ))}
        </div>
        <div className={styles.mobileLeft}>
          <Dropdown renderToggle={renderButton}>
            {TabsData2().map((item, index) => (
              <Dropdown.Item
                key={item.title}
                className={` ${
                  productsSortBy?.field === item.click.field &&
                  productsSortBy?.direction === item.click.direction
                    ? styles.activeItem
                    : ''
                }`}
                onClick={() =>
                  handleSortBy(item.click, TabsData3()[index].click)
                }
              >
                {item.title}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </div>
        <div className={styles.right}>
          <Button
            type="button"
            onClick={() => handleChange('full')}
            className={`${styles.type} ${cardsView === 'full' && styles.typeActive}`}
          >
            <IconType2 />
          </Button>
          <Button
            type="button"
            onClick={() => handleChange('card')}
            className={`${styles.type} ${cardsView === 'card' && styles.typeActive}`}
          >
            <IconType1 />
          </Button>
        </div>
        <Button
          type="button"
          onClick={openMobileMenu}
          className={styles.mobileRight}
        >
          {t('filters')}
        </Button>
      </div>
    </div>
  );
};

export default SecondContentTabs;
